<template>
  <tr :class="{ 'is-Disabled': disableEdits }">
    <td>
      <span class="postsTable__ItemTitle"
        >{{ item.name }}
        <small class="postsTable__ItemTitleNote" v-if="item.id === $store.state.accounts.user.id">{{
          $store.getters.getStringTranslation('thisIsYou')
        }}</small></span
      >
      <p class="postsTable__ItemCategory">{{ item.email }}</p>
      <ul class="postsTable__ItemActions">
        <li>
          <router-link
            tag="button"
            :disabled="disableEdits"
            :to="{ path: `user/edit/${item.id}`, params: { id: item.id } }"
            append
            >{{ $store.getters.getStringTranslation('edit') }}</router-link
          >
        </li>
        <li v-if="item.status === 'pending'">
          <button
            :disabled="disableEdits"
            @click="
              changeProp(item.id, { status: 'active' }, 'Success! User has been activated.')
              disableEditingUser()
            "
          >
            {{ $store.getters.getStringTranslation('approve') }}
          </button>
        </li>
      </ul>
    </td>
    <template v-if="showAdmin === true">
      <td v-if="item.is_org_admin"><icon name="check"></icon></td>
      <td v-else><icon name="times"></icon></td>
    </template>
  </tr>
</template>

<script>
export default {
  props: ['item', 'changeProp', 'showAdmin'],
  name: 'User',
  data() {
    return {
      disableEdits: false,
    }
  },
  methods: {
    disableEditingUser() {
      this.disableEdits = true
    },
  },
}
</script>
